import { createEvent } from 'effector';

export const clearSelectedBehalfEV = createEvent();
